<template>
  <div class="ui tiny modal" ref="modal">
    <i class="close icon"></i>
    <div class="header">
      <i class="user tie icon"></i>
      {{ $t("job possition setup") }}
    </div>
    <div class="image scrolling content">
      <div class="ui small image">
        <img src="/images/icons/employee.png" style="width: 100% !important" />
      </div>
      <div class="description" style="width: 100% !important">
        <div class="ui form" ref="form">
          <h4 class="ui dividing header">
            <i class="info icon"></i>
            {{ $t("general info") }}
          </h4>
          <div class="field">
            <label for>{{ $t("name") }}</label>
            <input type="text" name="name" v-model="type.name" />
          </div>
          <h4 class="ui dividing header">
            <i class="settings icon"></i>
            {{ $t("settings") }}
          </h4>
          <div class="two fields">
            <div class="field">
              <label for>{{ $t("default salary") }}</label>
              <input
                type="text"
                name="default_salary"
                v-model="type.setup.default_salary"
              />
            </div>
          </div>
          <div class="ui message error"></div>
        </div>
      </div>
    </div>
    <div class="actions">
      <div class="ui red icon right labeled deny button">
        <i class="remove icon"></i>
        {{ $t("close") }}
      </div>
      <div class="ui green icon right labeled button" @click="save">
        <i class="check icon"></i>
        {{ $t("ok") }}
      </div>
    </div>
  </div>
  <!-- </generic-modal> -->
</template>

<script>
import { local_api, error_toast } from "@/utils";

export default {
  name: "JobPossitionModal",
  components: {},
  computed: {},
  data() {
    return {
      type: {
        uuid: "",
        name: "",
        setup: {},
      },
    };
  },
  methods: {
    show_modal(opts) {
      let vm = this;

      /**
       * get element
       */
      if (opts && opts.uuid) {
        local_api(vm, "post", "/user_job_possition/do-get", {
          u: opts.uuid,
        })
          .then((r) => {
            if (r && r.name) vm.type.name = r.name;
            if (r && r.setup) vm.type.setup = r.setup;
            if (r && r.uuid) vm.type.uuid = r.uuid;
          })
          .catch((err) => {
            error_toast(err);
          });
      }

      window
        .jQuery(vm.$refs.modal)
        .modal({
          allowMultiple: true,
          onVisible() {},
          onHide() {
            vm.form.form("reset");
            vm.type = {
              uuid: "",
              name: "",
              setup: {},
            };
          },
        })
        .modal("show");

      vm.form = window.jQuery(vm.$refs.form).form({
        fields: {
          name: ["empty"],
        },
      });
    },
    save() {
      window.jQuery(this.$refs.form).form("validate form");
      let isValid = window.jQuery(this.$refs.form).form("is valid");
      let vm = this;
      if (isValid) {
        local_api(vm, "post", "/user_job_possition/do-save", {
          u: vm.type.uuid,
          n: vm.type.name,
          s: JSON.stringify(vm.type.setup),
        })
          .then(() => {
            vm.$emit("saved");
            window.jQuery(vm.$refs.modal).modal("hide");
          })
          .catch((err) => {
            window.jQuery(this.$refs.form).form("add errors", [err]);
          });
      }
    },
  },
  created() {},
  watch: {},
  updated: function () {},
};
</script>
